export default "__VITE_ASSET__7f47e782__"